export const SHOW_LOGIN_FORM = 'SHOW_LOGIN_FORM'
export const HIDE_LOGIN_FORM = 'HIDE_LOGIN_FORM'
export const SHOW_BUSINESS_FORM = 'SHOW_BUSINESS_FORM'
export const HIDE_BUSINESS_FORM = 'HIDE_BUSINESS_FORM'
export const SHOW_FAVORITE_BADGE = 'SHOW_FAVORITE_BADGE'
export const HIDE_FAVORITE_BADGE = 'HIDE_FAVORITE_BADGE'